<template>
  <div class="text-notes-list">
    <div class="row">
      <div class="col-md-8">
        <h1 v-translate>Gestion des notices rédactionnelles</h1>
        <label>
          <span v-translate>Recherche :</span>
          <input v-model="search" :placeholder="titles.search" class="form-control-sm filter-input" />
        </label>
      </div>
      <div class="col-md-4 carts-bar d-flex justify-content-end align-items-start">
        <router-link to="/artworks" class="btn btn-round" v-translate>Quitter cette page</router-link>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-3">
        <div class="d-flex">
          <span v-translate>Type de notice :</span>
          <span class="ml-4">
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" v-model="allTypes" />
                Tout
              </label>
            </div>
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" value="artwork" v-model="typeFilters" />
                Œuvre(s)
              </label>
            </div>
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" value="artist" v-model="typeFilters" />
                Artiste
              </label>
            </div>
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" value="cart" v-model="typeFilters" />
                Thématique
              </label>
            </div>
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" value="movement" v-model="typeFilters" />
                Mouvement
              </label>
            </div>
          </span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="d-flex">
          <span v-translate>Publiée :</span>
          <span class="ml-4">
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" v-model="allStatuses" />
                Tout
              </label>
            </div>
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" value="published" v-model="statusFilters" />
                Oui
              </label>
            </div>
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" value="none" v-model="statusFilters" />
                Non
              </label>
            </div>
          </span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex">
          <span v-translate>Action en cours :</span>
          <span class="ml-4">
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" v-model="allActions" />
                Tout
              </label>
            </div>
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" value="draft_external" v-model="actionFilters" />
                Modification en cours
              </label>
            </div>
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" value="publish_requested" v-model="actionFilters" />
                En attente de publication
              </label>
            </div>
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" value="unpublish_requested" v-model="actionFilters" />
                En attente de dépublication
              </label>
            </div>
            <div class="checkbox">
              <label class="mb-0">
                <input type="checkbox" value="none" v-model="actionFilters" />
                Aucune
              </label>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-sticky">
          <table class="">
            <thead>
              <tr>
                <th @click.stop.prevent="sortBy('id')" class="header-sort" :class="sortClass('id')">
                  <div v-translate>ID</div>
                </th>
                <th
                  @click.stop.prevent="sortBy('note_properties.title')"
                  class="header-sort"
                  :class="sortClass('note_properties.title')"
                >
                  <div v-translate>Titrage</div>
                </th>
                <th
                  @click.stop.prevent="sortBy('note_properties.type')"
                  class="header-sort"
                  :class="sortClass('note_properties.type')"
                >
                  <div v-translate>Type de notice</div>
                </th>
                <th
                  @click.stop.prevent="sortBy('note_properties.category')"
                  v-if="hasTextNoteCategories"
                  class="header-sort"
                  :class="sortClass('note_properties.category')"
                >
                  <div v-translate>Catégorie</div>
                </th>
                <th
                  @click.stop.prevent="sortBy('note_properties.author')"
                  class="header-sort"
                  :class="sortClass('note_properties.author')"
                >
                  <div v-translate>Rédacteur</div>
                </th>
                <th @click.stop.prevent="sortBy('updated_at')" class="header-sort" :class="sortClass('updated_at')">
                  <div v-translate>Dernière modification</div>
                </th>
                <th @click.stop.prevent="sortBy('external_id')" class="header-sort" :class="sortClass('external_id')">
                  <div v-translate>Publiée</div>
                </th>
                <th @click.stop.prevent="sortBy('status')" class="header-sort" :class="sortClass('status')">
                  <div v-translate>Action en cours</div>
                </th>
                <th @click.stop.prevent="sortBy('action')" class="header-sort" :class="sortClass('action')">
                  <div v-translate>Action</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <TextNotesRow
                :textNoteCategories="hasTextNoteCategories"
                :textNote="row"
                :key="row.id"
                v-for="row in filteredList"
              ></TextNotesRow>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col mt-4">
        <span>{{ filteredList.length }}</span>
        <span v-translate>résultats</span>
        <span v-if="filteredList.length">
          <TextNotesExportButton :filteredList="filteredList" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import stickybits from 'stickybits';
import { mapActions, mapGetters, mapState } from 'vuex';
import TextNotesRow from './TextNotesRow.vue';
import TextNotesExportButton from './TextNotesExportButton.vue';
import { text_notes_categories } from 'config';
import abilitiesMixin from 'mixins/abilitiesMixin';
import { TYPE_LABELS, STATUS_LABELS, ACTION_LABELS } from '../util/index';

export default {
  name: 'TextNotes',
  components: {
    TextNotesRow,
    TextNotesExportButton,
  },
  created() {
    this.fetch();
  },
  mounted() {
    stickybits(this.$el.getElementsByTagName('th'));
  },
  mixins: [abilitiesMixin],
  methods: {
    ...mapActions('textNotes', ['fetch']),
    hasTextNoteRole(row) {
      return (
        (this.$can('edit_own', 'text_note') && row.user_id === this.currentUser.id) ||
        this.$can('edit_all', 'text_note') ||
        this.$can('publish_all', 'text_note')
      );
    },
    sortBy: function (s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    sortClass: function (sort) {
      return {
        'sort-asc': this.currentSort === sort && this.currentSortDir === 'asc',
        'sort-desc': this.currentSort === sort && this.currentSortDir === 'desc',
      };
    },
  },
  computed: {
    ...mapGetters('textNotes', ['list']),
    ...mapState('auth', ['currentUser']),
    filteredList() {
      return this.list
        .filter(this.hasTextNoteRole)
        .filter((textNote) => {
          let re = new RegExp(this.search, 'i');
          let np = textNote.note_properties;
          let external = textNote.external_id ? this.$gettext('modification') : this.$gettext('création');

          let type;
          if (np.type === 'artwork') {
            type = this.$gettext('Œuvre(s)');
          } else if (np.type === 'artist') {
            type = this.$gettext('Artiste');
          } else {
            type = this.$gettext('Thématique');
          }

          let status = textNote.status === 'draft' ? this.$gettext('non') : this.$gettext('oui');

          return (
            !this.search ||
            re.test(textNote.id) ||
            re.test(external) ||
            re.test(type) ||
            re.test(np.owner) ||
            re.test(np.author) ||
            re.test(status) ||
            re.test(np.doc) ||
            re.test(np.title) ||
            re.test(np.category)
          );
        })
        .filter((textNote) => {
          let np = textNote.note_properties;
          return this.typeFilters.includes(np.type);
        })
        .filter((textNote) => {
          const status = textNote.external_id ? 'published' : 'none';
          return this.statusFilters.includes(status);
        })
        .filter((textNote) => {
          if (textNote.status === 'draft' && textNote.external_id) {
            return this.actionFilters.includes('draft_external');
          } else if (textNote.status === 'draft' || textNote.status === 'published') {
            return this.actionFilters.includes('none');
          } else {
            return this.actionFilters.includes(textNote.status);
          }
        })
        .sort((a, b) => {
          let modifier = 1;
          let aValue = this.currentSort.split('.').reduce((o, i) => o[i], a);
          let bValue = this.currentSort.split('.').reduce((o, i) => o[i], b);

          if (this.currentSort === 'note_properties.type') {
            aValue = TYPE_LABELS[aValue];
            bValue = TYPE_LABELS[bValue];
          }

          if (this.currentSort === 'external_id') {
            aValue = aValue ? true : false;
            bValue = bValue ? true : false;
          }

          if (this.currentSort === 'status') {
            aValue = aValue === 'draft' && a.external_id ? 'draft_external' : aValue;
            bValue = bValue === 'draft' && b.external_id ? 'draft_external' : bValue;

            aValue = STATUS_LABELS[aValue];
            bValue = STATUS_LABELS[bValue];
          }

          if (this.currentSort === 'action') {
            aValue = ACTION_LABELS[a.status];
            bValue = ACTION_LABELS[b.status];
          }

          if (this.currentSort === 'id') {
            aValue = parseInt(aValue);
            bValue = parseInt(bValue);
          }

          if (this.currentSortDir === 'desc') modifier = -1;

          if (typeof aValue === 'string') {
            return aValue.localeCompare(bValue, undefined, { sensitivity: 'base' }) * modifier;
          }

          if (aValue < bValue) return -1 * modifier;
          if (aValue > bValue) return 1 * modifier;
          return 0;
        });
    },
    hasTextNoteCategories() {
      return text_notes_categories && text_notes_categories.length > 0;
    },
    titles() {
      return {
        search: this.$gettext('Tapez une chaîne de caractères pour filtrer la liste'),
      };
    },
  },
  data() {
    return {
      search: '',
      currentSortDir: 'desc',
      currentSort: 'updated_at',
      typeFilters: ['artwork', 'artist', 'cart', 'movement'],
      statusFilters: ['published', 'none'],
      actionFilters: ['draft_external', 'publish_requested', 'unpublish_requested', 'none'],
      allTypes: true,
      allStatuses: true,
      allActions: true,
    };
  },
  watch: {
    allTypes(newVal, _) {
      if (newVal) {
        this.typeFilters = ['artwork', 'artist', 'cart', 'movement'];
      } else {
        this.typeFilters = [];
      }
    },
    allStatuses(newVal, _) {
      if (newVal) {
        this.statusFilters = ['published', 'none'];
      } else {
        this.statusFilters = [];
      }
    },
    allActions(newVal, _) {
      if (newVal) {
        this.actionFilters = ['draft_external', 'publish_requested', 'unpublish_requested', 'none'];
      } else {
        this.actionFilters = [];
      }
    },
  },
};
</script>
